<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card2 mRight" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap height-100p"
			>
				<div class="o-stack__cell">
					<h5 class="card-title">{{ sectiontitle }}</h5>
					<span class="datatable-icon" *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV($event)"
							target="_blank"
							*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
				<div class="analytics-portlet-content height-100p">
					<ngx-datatable
						#myTable
						class="datatable sem-keywords-table"
						[rows]="rows"
						[columnMode]="'force'"
						[headerHeight]="50"
						[footerHeight]="footerHeight"
						[reorderable]="false"
						[rowHeight]="50"
					>
						<ngx-datatable-row-detail [rowHeight]="innerRowHeight" #myDetailRow>
							<ng-template let-row="row" let-expanded="expanded" let-groupedRow="row" ngx-datatable-row-detail-template>
								<div class="inner-keywords-table scroll-container" [perfectScrollbar]="config">
									<ngx-datatable
										#innerTable
										class="keywords-table"
										[columnMode]="'force'"
										[rowHeight]="datatableconfig.rowHeight"
										[rows]="row.keywords"
										[reorderable]="false"
									>
										<ngx-datatable-column
											[resizeable]="false"
											[sortable]="false"
											[headerClass]="'expand'"
											[cellClass]="'expand'"
											[draggable]="false"
										>
											&nbsp;
										</ngx-datatable-column>

										<ng-template ngFor let-column [ngForOf]="columns">
											<ngx-datatable-column
												[resizeable]="false"
												[sortable]="true"
												[cellClass]="column.cellClass"
												[headerClass]="column.headerClass"
											>
												<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
													<div
														class="column-value"
														*ngIf="column.prop == 'name'; else RegularBlock"
														[title]="row.keyword"
													>
														{{ row.keyword }}
													</div>
													<ng-template #RegularBlock>
														<div *ngIf="column.suffix; else RegularRowInnerTable">
															<div class="column-value">{{ row[column.prop] | number }}%</div>
															<div class="progressbar" *ngIf="getMaxValues(groupedRow, column.prop)">
																<div
																	class="bar primary-color-bg"
																	[ngStyle]="getPercentage(row[column.prop], groupedRow, column.prop)"
																></div>
															</div>
														</div>
														<ng-template #RegularRowInnerTable>
															<div class="column-value">
																{{ row[column.prop] | number }}
															</div>
															<div class="progressbar" *ngIf="getMaxValues(groupedRow, column.prop)">
																<div
																	class="bar primary-color-bg"
																	[ngStyle]="getPercentage(row[column.prop], groupedRow, column.prop)"
																></div>
															</div>
														</ng-template>
													</ng-template>
												</ng-template>
											</ngx-datatable-column>
										</ng-template>
									</ngx-datatable>
								</div>
							</ng-template>
						</ngx-datatable-row-detail>
						<!-- Column Templates -->
						<ngx-datatable-column
							[resizeable]="false"
							[sortable]="false"
							[headerClass]="'expand'"
							[cellClass]="'expand'"
							[draggable]="false"
						>
							<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
								<a href="javascript:void(0)" title="Expand/Collapse Row" (click)="toggleExpandRow(row)">
									<i class="fa fa-angle-right" aria-hidden="true" *ngIf="!row['expand']"></i>
									<i class="fa fa-angle-down" aria-hidden="true" *ngIf="row['expand']"></i>
								</a>
							</ng-template>
						</ngx-datatable-column>

						<ng-template ngFor let-column [ngForOf]="columns">
							<ngx-datatable-column
								name="{{ column.name }}"
								prop="{{ column.prop }}"
								[resizeable]="false"
								[sortable]="true"
								[cellClass]="getClassName(column.cellClass)"
								[headerClass]="column.headerClass"
							>
								<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
									<span (click)="sort(); closeRows()" style="cursor: pointer;" *ngIf="!column.columnHasTooltip; else elseBlock">
										{{ colHeader.name }}
									</span>

									<ng-template #elseBlock>
										<span style="cursor: pointer;">
											<span
												(click)="sort(); closeRows()"
												appTooltip
												title="Tooltip"
												[title]="column.columnTooltip"
												data-size="small"
												[options]="tooltipOptions"
											>
												{{ colHeader.name }}
											</span>
										</span>
									</ng-template>
								</ng-template>

								<ng-template let-row="row" let-columnCell="column" ngx-datatable-cell-template>
									<strong *ngIf="column.suffix; else RegularRow">{{ row[column.prop] | number: '1.0-2' }}%</strong>
									<ng-template #RegularRow>
										<div *ngIf="column.prop != 'name'; else NameBlock">
											<strong>{{ row[column.prop] | number }}</strong>
										</div>
										<ng-template #NameBlock>
											<div>
												<strong style="cursor: pointer;" [title]="row[column.prop]">{{ row[column.prop] }}</strong>
											</div>
										</ng-template>
									</ng-template>
								</ng-template>
							</ngx-datatable-column>
						</ng-template>
					</ngx-datatable>
				</div>
			</div>
		</div>
		<div class="card1 mLeft"></div>
	</div>
</div>
